import React from 'react';
// import CapacitorSharedScanner from './CapacitorSharedScanner';
import SharedScanner from './SharedScanner';

export default (props) => <SharedScanner {...props} />;
// process.env.isCapacitor ? (
//   <CapacitorSharedScanner {...props} />
// ) : (
//   <SharedScanner {...props} />
// );
